import { render, staticRenderFns } from "./PokemonCardBadges.vue?vue&type=template&id=0beb3c3a&scoped=true"
import script from "./PokemonCardBadges.vue?vue&type=script&lang=js"
export * from "./PokemonCardBadges.vue?vue&type=script&lang=js"
import style0 from "./PokemonCardBadges.vue?vue&type=style&index=0&id=0beb3c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb3c3a",
  null
  
)

export default component.exports